export const LIST_SERVICE_REQUEST = 'LIST_SERVICE_REQUEST'
export const LIST_SERVICE_SUCCESS = 'LIST_SERVICE_SUCCESS'
export const LIST_SERVICE_FAILURE = 'LIST_SERVICE_FAILURE'
export const LIST_SERVICE_RESET = 'LIST_SERVICE_RESET'

export const LIST_SERVICE_SUMARY_REQUEST = 'LIST_SERVICE_SUMARY_REQUEST'
export const LIST_SERVICE_SUMARY_SUCCESS = 'LIST_SERVICE_SUMARY_SUCCESS'
export const LIST_SERVICE_SUMARY_FAILURE = 'LIST_SERVICE_SUMARY_FAILURE'
export const LIST_SERVICE_SUMARY_RESET = 'LIST_SERVICE_SUMARY_RESET'

export const CREATE_SERVICE_REQUEST = 'CREATE_SERVICE_REQUEST'
export const CREATE_SERVICE_SUCCESS = 'CREATE_SERVICE_SUCCESS'
export const CREATE_SERVICE_FAILURE = 'CREATE_SERVICE_FAILURE'

export const DETAIL_SERVICE_REQUEST = 'DETAIL_SERVICE_REQUEST'
export const DETAIL_SERVICE_SUCCESS = 'DETAIL_SERVICE_SUCCESS'
export const DETAIL_SERVICE_FAILURE = 'DETAIL_SERVICE_FAILURE'

export const UPDATE_SERVICE_REQUEST = 'UPDATE_SERVICE_REQUEST'
export const UPDATE_SERVICE_SUCCESS = 'UPDATE_SERVICE_SUCCESS'
export const UPDATE_SERVICE_FAILURE = 'UPDATE_SERVICE_FAILURE'

export const EXPORT_SERVICE_REQUEST = 'EXPORT_SERVICE_REQUEST'
export const EXPORT_SERVICE_SUCCESS = 'EXPORT_SERVICE_SUCCESS'
export const EXPORT_SERVICE_FAILURE = 'EXPORT_SERVICE_FAILURE'

export const UPDATE_SERVICE_CHANGE_SERVICE_CLASSIFICATION_REQUEST =
  'UPDATE_SERVICE_CHANGE_SERVICE_CLASSIFICATION_REQUEST'
export const UPDATE_SERVICE_CHANGE_SERVICE_CLASSIFICATION_SUCCESS =
  'UPDATE_SERVICE_CHANGE_SERVICE_CLASSIFICATION_SUCCESS'
export const UPDATE_SERVICE_CHANGE_SERVICE_CLASSIFICATION_FAILURE =
  'UPDATE_SERVICE_CHANGE_SERVICE_CLASSIFICATION_FAILURE'

export const DELETE_SERVICE_REQUEST = 'DELETE_SERVICE_REQUEST'
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS'
export const DELETE_SERVICE_FAILURE = 'DELETE_SERVICE_FAILURE'

export const LIST_SERVICE_ITEM_REQUEST = 'LIST_SERVICE_ITEM_REQUEST'
export const LIST_SERVICE_ITEM_SUCCESS = 'LIST_SERVICE_ITEM_SUCCESS'
export const LIST_SERVICE_ITEM_FAILURE = 'LIST_SERVICE_ITEM_FAILURE'
export const LIST_SERVICE_ITEM_RESET = 'LIST_SERVICE_ITEM_RESET'

export const ADD_ADDITIONAL_INFO_REQUEST = 'ADD_ADDITIONAL_INFO_REQUEST'
export const ADD_ADDITIONAL_INFO_SUCCESS = 'ADD_ADDITIONAL_INFO_SUCCESS'
export const ADD_ADDITIONAL_INFO_FAILURE = 'ADD_ADDITIONAL_INFO_FAILURE'

export const DELETE_ADDITIONAL_INFO_REQUEST = 'DELETE_ADDITIONAL_INFO_REQUEST'
export const DELETE_ADDITIONAL_INFO_SUCCESS = 'DELETE_ADDITIONAL_INFO_SUCCESS'
export const DELETE_ADDITIONAL_INFO_FAILURE = 'DELETE_ADDITIONAL_INFO_FAILURE'

export const LIST_ADDITIONAL_INFO_SERVICE_REQUEST =
  'LIST_ADDITIONAL_INFO_SERVICE_REQUEST'
export const LIST_ADDITIONAL_INFO_SERVICE_SUCCESS =
  'LIST_ADDITIONAL_INFO_SERVICE_SUCCESS'
export const LIST_ADDITIONAL_INFO_SERVICE_FAILURE =
  'LIST_ADDITIONAL_INFO_SERVICE_FAILURE'

export const LIST_MEDICAL_INFO_SUMMARY_REQUEST =
  'LIST_MEDICAL_INFO_SUMMARY_REQUEST'
export const LIST_MEDICAL_INFO_SUMMARY_SUCCESS =
  'LIST_MEDICAL_INFO_SUMMARY_SUCCESS'
export const LIST_MEDICAL_INFO_SUMMARY_FAILURE =
  'LIST_MEDICAL_INFO_SUMMARY_FAILURE'

export const SUMMARY_SERVICE_MEDINFO_SPECIMEN_REQUEST =
  'SUMMARY_SERVICE_MEDINFO_SPECIMEN_REQUEST'
export const SUMMARY_SERVICE_MEDINFO_SPECIMEN_SUCCESS =
  'SUMMARY_SERVICE_MEDINFO_SPECIMEN_SUCCESS'
export const SUMMARY_SERVICE_MEDINFO_SPECIMEN_FAILURE =
  'SUMMARY_SERVICE_MEDINFO_SPECIMEN_FAILURE'

export const UPADATE_SERVICE_MEDINFO_SPECIMEN_REQUEST =
  'UPADATE_SERVICE_MEDINFO_SPECIMEN_REQUEST'
export const UPADATE_SERVICE_MEDINFO_SPECIMEN_SUCCESS =
  'UPADATE_SERVICE_MEDINFO_SPECIMEN_SUCCESS'
export const UPADATE_SERVICE_MEDINFO_SPECIMEN_FAILURE =
  'UPADATE_SERVICE_MEDINFO_SPECIMEN_FAILURE'
  
export const SERVICE_FORMAT_OPTION_SUMMARY_REQUEST =
  'SERVICE_FORMAT_OPTION_SUMMARY_REQUEST'
export const SERVICE_FORMAT_OPTION_SUMMARY_SUCCESS =
  'SERVICE_FORMAT_OPTION_SUMMARY_SUCCESS'
export const SERVICE_FORMAT_OPTION_SUMMARY_FAILURE =
  'SERVICE_FORMAT_OPTION_SUMMARY_FAILURE'
  
export const UPDATE_FORMAT_OPTION_SERVICE_REQUEST =
  'UPDATE_FORMAT_OPTION_SERVICE_REQUEST'
export const UPDATE_FORMAT_OPTION_SERVICE_SUCCESS =
  'UPDATE_FORMAT_OPTION_SERVICE_SUCCESS'
export const UPDATE_FORMAT_OPTION_SERVICE_FAILURE =
  'UPDATE_FORMAT_OPTION_SERVICE_FAILURE'